// Application context: route, signed-in user, the server model for the current view, and navigation memory.
import { createContext, useContext } from 'react';
import type { DenomMode, MeDTO, ModelDTO, ZipRow } from '../../shared/types';

export interface Route { screen: string; arg: string | null; query: Record<string, string> }
export interface NavList { label: string; zips: string[] }

export interface Ctx {
  route: Route;
  me: MeDTO;
  model: ModelDTO;
  byZ: Record<string, ZipRow>;
  period: string;
  setPeriod: (p: string) => void;
  denom: DenomMode;
  vintage: string;
  setDenom: (mode: DenomMode, vintage?: string) => void;
  list: NavList | null;
  setList: (l: NavList | null) => void;
  notify: (m: string) => void;
  refresh: () => Promise<void>;
  viewQuery: string;
}

export const AppCtx = createContext<Ctx | null>(null);
export const useApp = (): Ctx => {
  const c = useContext(AppCtx);
  if (!c) throw new Error('AppCtx missing');
  return c;
};

export const useAppOptional = (): Ctx | null => useContext(AppCtx);

export function parseHash(): Route {
  const h = (location.hash || '#/overview').replace(/^#\/?/, '');
  const [p, q] = h.split('?');
  const parts = p.split('/').filter(Boolean);
  const query = Object.fromEntries(new URLSearchParams(q || ''));
  return { screen: parts[0] || 'overview', arg: parts[1] ? decodeURIComponent(parts[1]) : null, query };
}

export function go(hash: string): void { if (location.hash !== hash) location.hash = hash; }

export const isSvc = (r: { status: string }) => r.status === 'established' || r.status === 'new';

export const store = {
  get(k: string): string | null { try { return localStorage.getItem(k); } catch { return null; } },
  set(k: string, v: string): void { try { localStorage.setItem(k, v); } catch { /* storage unavailable */ } }
};
